var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchTeachersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_307",
    "data-name": "Group 307",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.008,
    height: 14.568,
    viewBox: "0 0 16.008 14.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 3.082,
    cy: 3.362,
    rx: 3.082,
    ry: 3.362,
    transform: "translate(3.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M8.683,14.009C6.5,13.929,2,15.017,2,17.2v1.6H9.636A4.762,4.762,0,0,1,8.683,14.009Z",
    transform: "translate(-2 -5.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M17.947,16.818A3.093,3.093,0,0,0,18.4,15.2a3.2,3.2,0,1,0-3.2,3.2,3.169,3.169,0,0,0,1.617-.456L18.875,20,20,18.875ZM15.2,16.8a1.6,1.6,0,1,1,1.6-1.6A1.606,1.606,0,0,1,15.2,16.8Z",
    transform: "translate(-3.996 -5.436)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchTeachersIcon);
export default __webpack_public_path__ + "static/media/searchTeachersIcon.5b294e40384ea81cc938da6775f21bc0.svg";
export { ForwardRef as ReactComponent };